/* tslint:disable */

declare var Object: any;
export interface QualificationInterface {
  "sfdcId"?: string;
  "Job_Order__c"?: string;
  "CreatedById"?: string;
  "CurrencyIsoCode"?: string;
  "LastModifiedById"?: string;
  "Name"?: string;
  "MinimalScore__c"?: number;
  "Parsed__c"?: boolean;
  "Required__c"?: boolean;
  "Skill_Name__c"?: string;
  "Taxonomy__c"?: string;
  "TaxonomySkill__c"?: string;
  "id"?: number;
  "createdAt"?: Date;
  "updatedAt"?: Date;
}

export class Qualification implements QualificationInterface {
  "sfdcId": string;
  "Job_Order__c": string;
  "CreatedById": string;
  "CurrencyIsoCode": string;
  "LastModifiedById": string;
  "Name": string;
  "MinimalScore__c": number;
  "Parsed__c": boolean;
  "Required__c": boolean;
  "Skill_Name__c": string;
  "Taxonomy__c": string;
  "TaxonomySkill__c": string;
  "id": number;
  "createdAt": Date;
  "updatedAt": Date;
  constructor(data?: QualificationInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `Qualification`.
   */
  public static getModelName() {
    return "Qualification";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of Qualification for dynamic purposes.
  **/
  public static factory(data: QualificationInterface): Qualification{
    return new Qualification(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'Qualification',
      plural: 'Qualifications',
      path: 'Qualifications',
      idName: 'id',
      properties: {
        "sfdcId": {
          name: 'sfdcId',
          type: 'string'
        },
        "Job_Order__c": {
          name: 'Job_Order__c',
          type: 'string'
        },
        "CreatedById": {
          name: 'CreatedById',
          type: 'string'
        },
        "CurrencyIsoCode": {
          name: 'CurrencyIsoCode',
          type: 'string'
        },
        "LastModifiedById": {
          name: 'LastModifiedById',
          type: 'string'
        },
        "Name": {
          name: 'Name',
          type: 'string'
        },
        "MinimalScore__c": {
          name: 'MinimalScore__c',
          type: 'number'
        },
        "Parsed__c": {
          name: 'Parsed__c',
          type: 'boolean'
        },
        "Required__c": {
          name: 'Required__c',
          type: 'boolean'
        },
        "Skill_Name__c": {
          name: 'Skill_Name__c',
          type: 'string'
        },
        "Taxonomy__c": {
          name: 'Taxonomy__c',
          type: 'string'
        },
        "TaxonomySkill__c": {
          name: 'TaxonomySkill__c',
          type: 'string'
        },
        "id": {
          name: 'id',
          type: 'number'
        },
        "createdAt": {
          name: 'createdAt',
          type: 'Date'
        },
        "updatedAt": {
          name: 'updatedAt',
          type: 'Date'
        },
      },
      relations: {
      }
    }
  }
}
